import BaseApi from '@/api/Base/BaseApi'
import {
  CreateModelRetrainNodeFromDqiPayload,
  CreateModelRetrainNodeFromModelDriftPayload,
  GetModelRetrainNodeDetailResponse,
  GetReferenceNodesPipelineInfoResponse,
  UpdateModelRetrainNodePayload,
  ModelRetrainExportPayload
} from '@/api/ModelRetrainNode/types'

const ROOT = '/model-retrain'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'asc',
  sortKey: 'datasetItemId',
}

export default class ModelRetrainNodeApi extends BaseApi {
  createModelRetrainNodeFromDqi(payload: CreateModelRetrainNodeFromDqiPayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}/modelRetrain/create`, rest)
  }

  createModelRetrainNodeFromModelDrift(payload: CreateModelRetrainNodeFromModelDriftPayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}/modelRetrain/create/model-drift`, rest)
  }

  updateModelRetrainNode(payload: UpdateModelRetrainNodePayload) {
    const { modelRetrainNodeId, name, ...rest } = payload
    return this.agent.put(`${ROOT}/${modelRetrainNodeId}`, { ...rest, name: name?.trim() })
  }

  exportModelRetrain(payload: ModelRetrainExportPayload) {
    const { modelRetrainNodeId, ...rest } = payload
    return this.agent.post(`${ROOT}/${modelRetrainNodeId}/export`, rest)
  }

  getModelRetrainNodeDetail(modelRetrainNodeId: string) {
    return this.agent.get<GetModelRetrainNodeDetailResponse>(`${ROOT}/${modelRetrainNodeId}`)
  }

  getReferenceNodesPipelineInfo(modelRetrainNodeId: string) {
    return this.agent.get<GetReferenceNodesPipelineInfoResponse>(`${ROOT}/${modelRetrainNodeId}/pipeline`)
  }

  // downloadModelRetrain(payload: any) {
  //   const { aiJobId, ...rest } = payload
  //   return this.agent.post(`${ROOT}/${aiJobId}/download`, rest)
  // }
}
